module.exports = __webpack_public_path__ + "media/images/desktop/edit-basket-337fc272fc2ffb13347c9f92be0a7024.svg";